import moment from 'moment';

import * as _ from 'lodash';
import * as types from './types';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';

const INITIAL_STATE = {
  fetching: false,
  data: [],
  fetchError: null,
};

const DateFormat = 'MM/DD/YYYY';

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SCHOOL_CALENDAR_LIST_FETCHING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.SCHOOL_CALENDAR_LIST_FETCH:
      return {
        ...state,
        data: action.payload.map(calendar => ({
          ...calendar,
          [Fields.FirstDayDT]: moment(calendar[Fields.FirstDayDT]).format(
            DateFormat
          ),
          [Fields.LastDayDT]: moment(calendar[Fields.LastDayDT]).format(
            DateFormat
          ),
          [Fields.MealExpirationDT]: calendar[Fields.MealExpirationDT]
            ? moment(calendar[Fields.MealExpirationDT]).format(DateFormat)
            : 'MBE Not Enabled',
        })),
      };

    case types.SCHOOL_CALENDAR_LIST_FETCH_ERROR:
      if (_.has(action.payload, 'response.data')) {
        const error = action.payload.response.data.Errors[0];

        return {
          ...state,
          error,
        };
      }

      return {
        ...state,
        error: {
          Title: 'Error',
          Message:
            'An error occurred while fetching School Calendars. Please try again',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendarList/reducer.js